/** The lobby of a hosted room (T5) — whom we are waiting for, how long is left, and who starts. */
export default {
  title: 'Room',
  code: 'Code',
  expires: 'The invitation expires in',
  expired: 'The invitation expired and two never arrived. Close the room and open another.',
  /* What a failed GET proves is that we could not ask — never that everybody left. */
  stale: 'The room could not be read: this is the last thing we knew.',
  /* "Nobody to ask" is NOT "nobody came": two tabs of one browser never go through the coordination
     plane, so there is no roster there to exist. */
  no_plane: 'This room does not go through the plane: there is no guest list to read.',
  host: 'host',

  /* The plane's four states. Four different things, hence four words. */
  state_invited: 'invited',
  state_accepted: 'accepted',
  state_connected: 'connected',
  state_left: 'left',
  /* And the fifth, which is not the plane's: having a BODY. An open channel is somebody who may still be
     reading the menu, and the host has to tell them apart to know whether he can start. */
  state_in_field: 'on the field',

  bodies: '{n} on the field — {sides} a side',
  start: 'Start the round',
  cut: 'Close the room',
  need_two: 'Two are needed, one a side',
  room_over: 'The plane declared this room over ({status}).',
  /* End of round, addressed to the HOST: everybody else reads it on the scoreboard, and the one hosting
     is the only one with something to decide afterwards. */
  round_over: 'The round is over. You can start another, or close the room.',
};
